<template>
  <v-card>
    <v-card-title>
      <span :class="['headline indigo--text text--darken-2 font-weight-medium']">{{header1}}</span>
      <span :class="['headline indigo--text text--darken-2 ml-2']">expense</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 320px;">
      <v-row dense>
        <v-col cols="6">
          <AADate label="Expense Date" :date="item.date" v-on:date-changed="item.date = $event" />
        </v-col>
        <v-col cols="6">
          <v-text-field hide-details type="number" label="Value" v-model="item.value"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field hide-details label="Description" v-model="item.description"></v-text-field>
        </v-col>
        <v-col cols="12" class="mt-5">
          <v-row align="center">
            <v-col cols="12">
              <v-checkbox
                v-model="isChecked"
                hide-details
                class="shrink mr-2 mt-0"
                label="Link to a work-item / stage:"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" class="shrink mt-n4">
              <v-select
                :disabled="!isChecked"
                :items="workItems"
                item-text="name"
                item-value="wiid"
                v-model="item.wiid"
                menu-props="auto"
                label="Select Work-item / Stage"
                hide-details
                solo
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn v-if="!inNewMode" color="red darken-1" text @click="obj.remove(obj.item)">Delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="accept">Save</v-btn>
      <v-btn color="green darken-1" text @click="obj.close()">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from "vue";
import AADate from "@/components/AADate";
import { getFormattedValue } from "@/shared.js";

export default {
  components: { AADate },
  props: {
    obj: Object
  },
  name: "DialogProjectExpenseItem",
  data() {
    return {};
  },
  watch: {},
  computed: {
    item() {
      console.log("expense item() called.... ");
      return this.obj.item;
    },
    isChecked: {
      get() {
        if (!this.item.hasOwnProperty("isChecked"))
          Vue.set(this.item, "isChecked", !!this.item.wiid);
        return !!this.item.wiid || this.item.isChecked;
      },
      set(newValue) {
        this.item.isChecked = newValue;
        if (!newValue) this.item.wiid = "";
      }
    },
    inNewMode() {
      return this.obj.inNewMode;
    },
    header1() {
      if (this.inNewMode) return "New";
      return "Edit";
    },
    workItems() {
      let xx = this.$store.getters.selectedProjectWorkItems;
      return xx;
    }
  },
  methods: {
    accept() {
      // remove the helper checked prop
      delete this.obj.item.isChecked;

      // call back
      this.obj.update(this.obj.item);
    }
  }
};
</script>

<style scoped>
</style>
